import React, { useState } from 'react';
import styles from '../../ChargebackProtection.module.css';

const faqData = [
  {
    q: 'What counts as a fraudulent dispute?',
    a: 'A dispute where the charge wasn\'t authorized by the real cardholder, or where a customer falsely claims they didn\'t make or authorize a legitimate purchase ("friendly fraud"). Those are the claims this protection is built for.',
  },
  {
    q: "What isn't covered?",
    a: 'Refunds you agree to, service or quality complaints, "item not as described" claims, and anything outside the eligibility terms. Chargeback Protection is for fraud — not ordinary customer-service disputes.',
  },
  {
    q: 'Do I have to fight the dispute myself?',
    a: 'No. For eligible fraud claims, Fyntiq gathers the evidence and submits the response for you, then covers the claim if it qualifies. You can follow the status in your dashboard.',
  },
  {
    q: 'Is there a cost or coverage limit?',
    a: "Coverage, any limits, and eligibility are defined in your merchant agreement. See the Pricing page for what's included on each plan.",
  },
  {
    q: 'Will disputes affect my account?',
    a: 'Fyntiq handles eligible fraud disputes on your behalf and works to keep your account in good standing. Excessive non-fraud disputes are still your responsibility to resolve.',
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Protection questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div className={styles.faqQ} onClick={() => setOpenIndex(openIndex === i ? -1 : i)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}>
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
